import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

export const getNotifications = async (page, pageSize) => {
    const response = await apiService.get(apiRoutes.adminNotifications, page,pageSize);
    return response.data;
  };

export const getNotificationDetails = async (id) => {
  const response = await apiService.get(apiRoutes.adminNotificationDetails + `/${id}`);
  return response.data;
};


export const sendNotification = async (data) => {
  const response = await apiService.post(apiRoutes.adminSendNotification, data);
  return response.data;
};


export const destroyNotification = async (id) => {
  const response = await apiService.post(apiRoutes.adminNotificationDestroy, id);
  return response.data;
};


